(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-clients"] && !Shopify.designMode) return;
  try {
    
class AvisCarousel {
  constructor(root){
    this.root = root;
    if (!root || root.dataset.mode !== 'carousel') return;
    this.track = root.querySelector('.avis-adv__track');
    this.cards = [...this.track.children];
    this.btnPrev = root.querySelector('.avis-adv__arrow.prev');
    this.btnNext = root.querySelector('.avis-adv__arrow.next');
    this.dotsWrap = root.querySelector('.avis-adv__dots');
    this.perDesktop = parseInt(root.dataset.perDesktop || '3');
    this.perMobile = parseInt(root.dataset.perMobile || '1');
    this.loop = root.dataset.loop === 'true';
    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = parseInt(root.dataset.speed || '4000');
    this.dragDesktop = root.dataset.dragDesktop === 'true';
    this.index = 0;

    // dots
    if (this.dotsWrap){
      const pages = this.totalPages();
      for (let i=0;i<pages;i++){
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Aller à la page ${i+1}`);
        b.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(b);
      }
    }
    this.update();

    this.btnPrev && this.btnPrev.addEventListener('click', () => this.prev());
    this.btnNext && this.btnNext.addEventListener('click', () => this.next());

    if (this.autoplay){
      this.timer = setInterval(() => this.next(), this.speed);
      this.root.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.root.addEventListener('mouseleave', () => { this.timer = setInterval(() => this.next(), this.speed); });
    }

    // drag souris (desktop)
    if (this.dragDesktop){
      let isDown = false, startX = 0, startScroll = 0;
      const onDown = (x)=>{ if (window.innerWidth < 750) return; isDown = true; this.track.classList.add('is-dragging'); startX = x; startScroll = this.track.scrollLeft; };
      const onMove = (x)=>{ if (!isDown) return; const walk = (x - startX); this.track.scrollLeft = startScroll - walk; };
      const onUp = ()=>{ isDown = false; this.track.classList.remove('is-dragging'); };

      this.track.addEventListener('mousedown', e => onDown(e.pageX));
      this.track.addEventListener('mousemove', e => onMove(e.pageX));
      document.addEventListener('mouseup', onUp);

      this.track.addEventListener('touchstart', e => onDown(e.touches[0].pageX), {passive:true});
      this.track.addEventListener('touchmove', e => onMove(e.touches[0].pageX), {passive:true});
      this.track.addEventListener('touchend', onUp);
    }

    window.addEventListener('resize', () => this.update(true));
  }
  perView(){ return window.innerWidth < 750 ? this.perMobile : this.perDesktop; }
  totalPages(){ return Math.max(1, Math.ceil(this.cards.length / this.perView())); }
  goTo(page){
    this.index = Math.max(0, Math.min(page, this.totalPages()-1));
    const width = this.track.getBoundingClientRect().width;
    const offset = width * this.index;
    this.track.scrollTo({left: offset, behavior:'smooth'});
    this.updateDots();
  }
  next(){
    let i = this.index + 1;
    const last = this.totalPages() - 1;
    if (i > last) i = this.loop ? 0 : last;
    this.goTo(i);
  }
  prev(){
    let i = this.index - 1;
    if (i < 0) i = this.loop ? (this.totalPages()-1) : 0;
    this.goTo(i);
  }
  updateDots(){
    if (!this.dotsWrap) return;
    [...this.dotsWrap.children].forEach((d,i)=> d.setAttribute('aria-current', i===this.index ? 'true':'false'));
  }
  update(reset=false){ if (reset) this.index = 0; this.goTo(this.index); }
}

// “Lire plus”
function initClamp(root){
  root.querySelectorAll('.avis-card').forEach(card=>{
    const text = card.querySelector('.avis-card__text.is-clamp');
    const btn = card.querySelector('.avis-card__more');
    if (!text || !btn) return;
    btn.addEventListener('click', ()=>{
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      text.classList.toggle('is-clamp');
      btn.textContent = expanded ? 'Lire plus' : 'Réduire';
    });
  });
}

// reveal on scroll
function initReveal(){
  document.querySelectorAll('[data-reveal]').forEach(wrap=>{
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if (e.isIntersecting){ wrap.classList.add('is-visible'); io.disconnect(); }});
    },{threshold:.15});
    io.observe(wrap);
  });
}

document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelectorAll('.avis-adv').forEach(section=>{
    if (section.dataset.mode === 'carousel'){
      new AvisCarousel(section);
    }
    initClamp(section);
  });
  initReveal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mvp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
